function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2029_11149)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.0051 0H3.9949C1.78858 0 0 1.78858 0 3.9949V12.0051C0 14.2114 1.78858 16 3.9949 16H12.0051C14.2114 16 16 14.2114 16 12.0051V3.9949C16 1.78858 14.2114 0 12.0051 0Z",
  fill: "url(#paint0_linear_2029_11149)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0051 0H3.9949C1.78858 0 0 1.78858 0 3.9949V12.0051C0 14.2114 1.78858 16 3.9949 16H12.0051C14.2114 16 16 14.2114 16 12.0051V3.9949C16 1.78858 14.2114 0 12.0051 0Z",
  fill: "url(#paint1_radial_2029_11149)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.12864 14.0553C6.92852 14.0553 6.37081 13.8801 5.40139 13.1793C4.78819 13.9677 2.84641 14.5838 2.76172 13.5297C2.76172 12.7384 2.58652 12.0697 2.38796 11.3397C2.15145 10.4404 1.88281 9.43883 1.88281 7.98761C1.88281 4.5216 4.72688 1.91406 8.09652 1.91406C11.4691 1.91406 14.1117 4.65008 14.1117 8.01973C14.123 11.3373 11.4462 14.0376 8.12864 14.0553ZM8.17828 4.90995C6.53726 4.82528 5.2583 5.96115 4.97507 7.74233C4.74147 9.21693 5.15611 11.0127 5.50942 11.1061C5.67878 11.147 6.1051 10.8025 6.37081 10.5368C6.81019 10.8403 7.32185 11.0226 7.85417 11.0653C9.55454 11.1471 11.0075 9.85256 11.1216 8.15406C11.1881 6.45195 9.87889 5.01029 8.17828 4.91288V4.90995Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2029_11149",
  x1: 1.88555,
  y1: 12.1686,
  x2: 16,
  y2: 8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#44CCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.662,
  stopColor: "#5533EE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9933DD"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_2029_11149",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-0.380653 -7.02697) rotate(51.356) scale(19.4163 8)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0000FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2029_11149"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgMaxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxIcon);
export default __webpack_public_path__ + "static/media/max-icon.7ece12a3.svg";
export { ForwardRef as ReactComponent };